import Avatar from './Avatar.vue';
export default {
    components: { Avatar },
    props: {
        profiles: {
            type: Array,
            default: () => {
                return [];
            },
        },
        maxVisibleAvatars: { type: Number, default: -1 },
    },
    computed: {
        scrollStyle() {
            return this.maxVisibleAvatars > 0
                ? `overflow-y: auto; max-height: ${47 * this.maxVisibleAvatars}px`
                : 'overflow-y: visible';
        },
    },
};
